module.exports = __webpack_public_path__ + "img/inadequate.eb78246a.png";